import { defineMessages } from 'react-intl'

const scope = 'app.components.EditOrganizationModal'

export default defineMessages({
  labels: {
    name: {
      id: `${scope}.labels.name`,
      defaultMessage: 'Organization Name',
    },
    alias: {
      id: `${scope}.labels.alias`,
      defaultMessage: 'Customer Alias',
    },
    domains: {
      id: `${scope}.labels.domains`,
      defaultMessage: 'Domains',
    },
  },
  formFeedback: {
    nameUnavailable: {
      id: `${scope}.formFeedback.nameUnavailable`,
      defaultMessage: 'Organization name is already taken',
    },
  },
}) 